// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { fromUnixTime as fn } from "../fromUnixTime.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const fromUnixTime = convertToFP(fn, 1);

// Fallback for modularized imports:
export default fromUnixTime;
